import { useState } from 'react';
import { useQuery } from 'react-query';

import { getCustomerProducts } from 'queries';
import { PrepaidProductStatus } from 'types';

type PrepaidProduct = {
  ID: number;
  customer_ID: number;
  product_ID: number;
  status: string; // 'new'
  service_ID: number;
  product_name: string;
  total: string;
  purchase_date: string; // '05/12/2021 10:43'
};

export const useCustomerProducts = (cusotmerId: number | null, status: PrepaidProductStatus | '') => {
  const [prepaidProductsIds, setPrepaidProductsIds] = useState<number[]>();
  const { data, isLoading } = useQuery(['customer-products', cusotmerId as number, status], getCustomerProducts, {
    enabled: !!cusotmerId,
    onSuccess: (data) =>
      setPrepaidProductsIds(data?.map((product: PrepaidProduct) => product?.product_ID).filter(Boolean)),
  });

  return { prepaidProducts: data, prepaidProductsIds, isPrepaidProductsLoading: isLoading };
};
